/* unplugin-vue-components disabled */import script from "./Bottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./Bottom.vue?vue&type=script&setup=true&lang=ts"

import "./Bottom.vue?vue&type=style&index=0&id=4138f574&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4138f574"]])

export default __exports__